// extracted by mini-css-extract-plugin
export default {"ListContainer":"ChannelResult_ListContainer__a6puQ"};